/**
 * Application Configuration
 * Central configuration file for environment variables and app settings
 */

// API Configuration
// In development, use proxy (relative URL) - setupProxy.js handles proxying to backend
// In production, API is served from the same origin
// If REACT_APP_API_BASE_URL is set, use it; otherwise use relative URL
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Google OAuth Configuration
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Environment
export const ENV = process.env.REACT_APP_ENV || 'development';
export const IS_DEVELOPMENT = ENV === 'development';
export const IS_PRODUCTION = ENV === 'production';

// Optional: Google API Key (if using Google services directly)
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || '';

// Feature Flags (can be controlled via environment variables)
export const ENABLE_BETA_FEATURES = process.env.REACT_APP_ENABLE_BETA_FEATURES === 'true';
export const ENABLE_ANALYTICS = process.env.REACT_APP_ENABLE_ANALYTICS === 'true';

// API Timeouts (in milliseconds)
export const API_TIMEOUT = 30000; // 30 seconds
export const FILE_UPLOAD_TIMEOUT = 120000; // 2 minutes

// File Upload Limits
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'text/plain',
  'image/jpeg',
  'image/png',
];

// Pagination Defaults
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100;

// Local Storage Keys
export const STORAGE_KEYS = {
  USER: 'user',
  AUTH_TOKEN: 'authToken',
  THEME: 'theme',
} as const;

// Validation
if (IS_PRODUCTION && !GOOGLE_CLIENT_ID) {
  console.warn('Warning: GOOGLE_CLIENT_ID is not set in production environment');
}

if (IS_PRODUCTION && !API_BASE_URL.startsWith('https://')) {
  console.warn('Warning: API_BASE_URL should use HTTPS in production');
} 